import React from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import AuthenticatedNavbar from "../headers/AuthenticatedNavbar";
import GroupsHubContent from "../groups/Groups.js";
import { isAdmin } from "../../utils/userRole";

const ADMIN_NAV_LINKS = [
  { label: "Posts", target: "/admin" },
  { label: "Groups", target: "/admin/groups" },
  { label: "Hiring", target: "/hiringmanagement" },
  { label: "Analytics", target: "/analytics" },
  { label: "Assistant", target: "/assistant" },
];

/**
 * Dedicated admin page to browse every group and delete any of them.
 */
export default function GroupsManagement({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin(user)) {
    return <Navigate to="/home" replace />;
  }

  return (
    <div style={{ width: "100%", margin: 0, padding: 0 }}>
      <AuthenticatedNavbar user={user} onLogout={onLogout} />
      <div
        style={{
          padding: "10px 20px",
          backgroundColor: "#eef2ff",
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        {ADMIN_NAV_LINKS.map((link) => {
          const isActive = location.pathname === link.target;
          return (
            <button
              type="button"
              key={link.target}
              onClick={() => navigate(link.target)}
              style={{
                borderRadius: "999px",
                padding: "8px 18px",
                border: "1px solid #cbd5f5",
                backgroundColor: isActive ? "#1d4ed8" : "#fff",
                color: isActive ? "#fff" : "#1b2650",
                borderColor: isActive ? "#1d4ed8" : "#cbd5f5",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              {link.label}
            </button>
          );
        })}
      </div>
      <GroupsHubContent user={user} defaultTab="admin" />
    </div>
  );
}
